import { render } from "./VODskeleton.vue?vue&type=template&id=0db83ec7"
import script from "./VODskeleton.vue?vue&type=script&lang=js"
export * from "./VODskeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__